import React from 'react';
import { CheckCircle } from 'lucide-react';
import type { Language } from '@/lib/i18n';
import { t } from '@/lib/i18n';

type StepType = 'theory' | 'example' | 'exercise' | 'quiz' | 'result';

const STEP_LABELS: Record<StepType, 'lesson_theory' | 'lesson_example' | 'lesson_exercise' | 'lesson_quiz' | 'lesson_result'> = {
  theory: 'lesson_theory',
  example: 'lesson_example',
  exercise: 'lesson_exercise',
  quiz: 'lesson_quiz',
  result: 'lesson_result',
};

interface Props {
  steps: StepType[];
  currentIndex: number;
  language: Language;
}

export default function LessonProgressBar({ steps, currentIndex, language }: Props) {
  return (
    <div className="flex items-center gap-2">
      {steps.map((step, i) => {
        const isCompleted = i < currentIndex;
        const isCurrent = i === currentIndex;
        return (
          <React.Fragment key={`step-${step}`}>
            <div className="flex flex-col items-center gap-1">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
                  isCompleted
                    ? 'bg-success text-white'
                    : isCurrent
                    ? 'bg-primary text-white' :'bg-muted text-muted-foreground'
                }`}
              >
                {isCompleted ? (
                  <CheckCircle size={14} />
                ) : (
                  <span className="text-xs font-700">{i + 1}</span>
                )}
              </div>
              <span className={`text-xs font-500 hidden sm:block ${isCurrent ? 'text-primary' : 'text-muted-foreground'}`}>
                {t(language, STEP_LABELS[step])}
              </span>
            </div>
            {i < steps.length - 1 && (
              <div
                className={`flex-1 h-0.5 rounded-full transition-all duration-300 ${
                  i < currentIndex ? 'bg-success' : 'bg-muted'
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}